export enum CssSource
{
    Within = 0,
    FromOutside = 1
}
